import { DEFAULT_BACKEND_URL } from '@foundation/network/services';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { fromEvent } from 'rxjs';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production && environment.sentry.domain && window.origin.includes(environment.sentry.domain)) {
	console.log('Initializing Sentry for production environment:', environment.sentry.domain);
	Sentry.init(environment.sentry.initConfig ?? {});
} else {
	console.log('Sentry not initialized for non-production environment or domain mismatch.', { origin: window.origin, sentry: environment.sentry });
}

if (window.origin.includes('localhost:4200')) {
	console.log('Running on localhost, fetching data without WithCredentials to get first cookie');
	fetch(DEFAULT_BACKEND_URL + '/test-api/stateless?' + Math.random()).then((response) => {
		// console.log('\tResponse from fetch', response);
		// // print headers:
		// response.headers.forEach((value, name) => {
		// 	console.log('\tResponse from fetch: header', `${name}: ${value}`);
		// });
	});
}

if (!environment.production) console.log('Environment', environment);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));

// const bananaColorPurple = '#a92177';
// const bananaColorYellow = '#FBDB03';
// applyColorTheme(document.documentElement, bananaColorPurple);

// Create an observable from the 'change' event
fromEvent(window.matchMedia('(prefers-color-scheme: dark)'), 'change').subscribe(() => {
	// applyColorTheme(document.documentElement, bananaColorPurple);

	const systemDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

	console.log('Dark mode?', systemDark ? '🌚' : '🌞');

	// set html var --some-color to red:
	document.documentElement.style.setProperty('--some-color', systemDark ? 'yellow' : 'green');
});

// document.documentElement.style.setProperty('--md-sys-color-primary', bananaColorYellow);

// generateColorTheme(document.documentElement, bananaColorYellow);

// document.addEventListener('paste', (event) => {
// 	console.log('PASTE @@@@@@@@@@@', event);
// });

// // MEMORY STATS

// const stats = MemoryStats();

// stats.domElement.style.position = 'fixed';
// stats.domElement.style.right = '0px';
// stats.domElement.style.bottom = '0px';

// document.body.appendChild(stats.domElement);

// // via setTimeout
// setTimeout(function sTOloop() {
// 	stats.update();
// 	setTimeout(sTOloop, 200);
// }, 200);
